/**
* description:
* File of sDate Serivce
*
* Serwis jest odpowiedzialny za funkcje pomocnicze do obsługi obiektów dat.
*
* data : 2017-08-24
*/

const sDate = (() => {
  return {
    formatDate,
    getDateFromToday,
    getDateByDay,
    addMonths,
    getYesterdayDate,
  };
  // /// PUBLIC /////////////////////////////////////////////////////////////////
  /**
  * Metoda do pobrania łańcuchu daty w formacie YYYY-MM-DD z przekazanego obiektu daty.
  *
  * @method formatDate(dateObject)
  * @param {Object} dateObject - obiekt daty przekazany do funkcji
  * @return {String} łańcuch daty w formacie YYYY-MM-DD
  * @access public
  */
  function formatDate(dateObject) {
    let d = new Date(dateObject);
    let month = `${d.getMonth() + 1}`;
    let day = `${d.getDate()}`;
    let year = d.getFullYear();

    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;

    return [year, month, day].join('-');
  }
  /**
  * Metoda zwraca datę początkową dla okresu jaki wybrał użytkownik ('ostatnie X dni'),
  * czyli 'zwróć mi datę ${daysAmount} dni od dzisiaj'.
  *
  * @method getDateFromToday(daysAmount)
  * @param {Integer} daysAmount - liczba dni od dnia dzisiejszego, które nas interesują
  * @return {String} łańcuch daty w formacie YYYY-MM-DD
  * @access public
  */
  function getDateFromToday(daysAmount) {
    const today = new Date();
    const date = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() - daysAmount,
    );
    return this.formatDate(date);
  }
  /**
  * Metoda w zależności od parametrów może zwrócić trzy różne daty:
  * - pierwszy dzień poprzedniego miesiąca, gdy ordinal = 'firstDay', month != 'currentMonth'
  * - ostatni dzień poprzedniego miesiąca, gdy ordinal != 'firstDay', month = 'currentMonth'
  * - pierwszy dzień obecnego miesiąca, gdy ordinal = 'firstDay', month = 'currentMonth'
  *
  * @method getDateByDay(ordinal, month)
  * @param {String} ordinal - jeśli 'firstDay' to zwraca pierwszy dzień,
  *                            w innym wypadku zwraca 'dzień poprzedzający'
  * @param {String} month - jeśli 'currentMonth' to zwraca obecny miesiąc,
  *                          w innym wypadku zwraca poprzedni
  * @return {String} łańcuch daty w formacie YYYY-MM-DD
  * @access public
  */
  function getDateByDay(ordinal, month) {
    const today = new Date();
    const monthUsed = month === 'currentMonth' ? today.getMonth() : today.getMonth() - 1;
    const dayUsed = ordinal === 'firstDay' ? 1 : 0;
    const date = new Date(
      today.getFullYear(),
      monthUsed,
      dayUsed,
    );
    return this.formatDate(date);
  }
  /**
  * Metoda dodaje wybraną ilość miesięcy i dodaje do przekazanej daty.
  * Jeśli zwrócona data jest późniejsza niż wczoraj, zwraca wczoraj
  * (wczoraj jest najnowszą możliwą datą do wyszukania).
  *
  * @method addMonths(date, months)
  * @param {Date} date - data do której chcemy dodać miesiące
  * @param {Integer} months - liczba miesięcy do dodania
  * @return {String} łańcuch daty w formacie YYYY-MM-DD
  * @access public
  */
  function addMonths(date, months) {
    const yesterday = (d => new Date(d.setDate(d.getDate() - 1)))(new Date());
    let newDate = new Date(date.getTime());
    newDate.setMonth(date.getMonth() + months);
    return newDate < yesterday ? newDate : yesterday;
  }
  /**
  * Metoda zwraca użytkownikowi obiekt z wczorajszą datą.
  * Potrzebny gdyż większość wyszukiwań zakłada wczoraj jako najnowszy możliwy dzień.
  *
  * @method getYesterdayDate()
  * @return {String} obiekt wczorajszej daty
  * @access public
  */
  function getYesterdayDate() {
    return (d => new Date(d.setDate(d.getDate() - 1)))(new Date());
  }
})();

export default sDate;



// WEBPACK FOOTER //
// ./src/services/sDate.js